import { createTranslationRequest, fetchMyTranslationRequest, fetchMyTranslationRequests, updateTranslationRequest } from "../api/TranslationRequestApi";
import { TranslationRequest } from "../model/Translation";
import { TranslationsResponse } from "../model/TranslationsResponse";
import { getCurrentDateTime, getUserLocale } from "../utils/DetailsUtils";

export interface TranslationRequestRepositoryContract {

    createTranslation(
        title: string,
        originalLanguage: string,
        toLanguage: string,
        files: string,
        type: string
    ): Promise<TranslationRequest>

    updateTranslation(request: TranslationRequest): Promise<Boolean>

    fetchMyRequests(lastPartitionKey?: string | undefined, lastRangeKey?: string |undefined): Promise<TranslationsResponse>

    fetchTranslation(partitionKey: string, rangeKey: string): Promise<TranslationRequest>
}

class TranslationRequestRepository implements TranslationRequestRepositoryContract {

    private recentTranslationRequest: TranslationRequest | null = null

    async createTranslation(title: string, originalLanguage: string, toLanguage: string, files: string, type: string): Promise<TranslationRequest> {
        try {
            let userLocale = getUserLocale();
            var requestTitle = title;
            if (title.length === 0) {
                requestTitle = `TranslationRequest to ${toLanguage} - ${getCurrentDateTime(userLocale)}`;
            }
            let request = await createTranslationRequest(
                originalLanguage,
                toLanguage,
                userLocale,
                files,
                requestTitle, 
                type
            );
            this.recentTranslationRequest = request;
            return request;
        } catch (error) {
            console.log(`Error from backend: ${error}`)
            throw error;
        }

    }

    async updateTranslation(request: TranslationRequest): Promise<Boolean> {
        try {
            let update = updateTranslationRequest(request);
            return update;
        } catch(error) {
            return false;
        }
    }

    async fetchTranslation(partitionKey: string, rangeKey: string): Promise<TranslationRequest> {
        try {
            let request = fetchMyTranslationRequest(partitionKey, rangeKey)
            return request;
        } catch(error) {
            throw error;
        }
    }

    async fetchMyRequests(lastPartitionKey?: string | undefined, lastRangeKey?: string |undefined): Promise<TranslationsResponse> {
        try {
            return fetchMyTranslationRequests(lastPartitionKey, lastRangeKey);
        } catch(error) {
            throw error
        }
    }

}

export default new TranslationRequestRepository();